// Shared tag colour palette. Keys are persisted in `merchant_tags.color`.
export const TAG_PALETTE: Record<string, { bg: string; fg: string; dot: string }> = {
  blue:   { bg: "hsl(212 90% 94%)", fg: "hsl(212 70% 30%)", dot: "hsl(212 80% 50%)" },
  green:  { bg: "hsl(142 70% 92%)", fg: "hsl(142 60% 26%)", dot: "hsl(142 65% 42%)" },
  orange: { bg: "hsl(28 95% 92%)",  fg: "hsl(22 70% 32%)",  dot: "hsl(25 90% 52%)" },
  red:    { bg: "hsl(0 85% 94%)",   fg: "hsl(0 65% 36%)",   dot: "hsl(0 75% 52%)" },
  purple: { bg: "hsl(270 80% 94%)", fg: "hsl(270 55% 36%)", dot: "hsl(270 65% 56%)" },
  pink:   { bg: "hsl(330 85% 94%)", fg: "hsl(330 60% 36%)", dot: "hsl(330 75% 56%)" },
  teal:   { bg: "hsl(174 70% 90%)", fg: "hsl(174 65% 25%)", dot: "hsl(174 65% 38%)" },
  lime:   { bg: "hsl(82 75% 88%)",  fg: "hsl(82 55% 24%)",  dot: "hsl(82 60% 40%)" },
};

export const TAG_PALETTE_KEYS = Object.keys(TAG_PALETTE);

export const fallbackTagColorKey = (tag: string) => {
  let h = 0;
  for (let i = 0; i < tag.length; i++) h = (h * 31 + tag.charCodeAt(i)) % TAG_PALETTE_KEYS.length;
  return TAG_PALETTE_KEYS[h];
};

export const swatchForTag = (key?: string | null) =>
  TAG_PALETTE[key ?? ""] ?? TAG_PALETTE[fallbackTagColorKey(key ?? "")];
